<!-- Navigation menu -->
<app-menu></app-menu>

<!-- Map -->
<!-- Displayed using [ngStyle] value of mapWidth -->
<div id="viewDiv" [ngStyle]="{width: mapWidth}">

    <!-- Info widget -->
    <div id="infoBtn" class="esri-widget--button esri-widget esri-interactive home" role="button" title="About" tabindex="0" (click)="openAboutTextDialog()" (keyup.enter)="openAboutTextDialog()" (keyup.space)="openAboutTextDialog()">
        <span aria-hidden="true" role="presentation" class="esri-icon esri-icon-description"></span>
    </div>
    <!-- Table View/Edit -->
    <!-- Displayed using [ngStyle] value of tableBtnDisplayType -->
    <div id="tableBtn" [ngStyle]="{display: tableBtnDisplayType}" [ngClass]="tableActive ? 'tableActive' : ''" class="esri-widget--button esri-widget esri-interactive home" role="button" title="Table" tabindex="0" (click)="toggleTable()" (keyup.enter)="toggleTable()"
        (keyup.space)="toggleTable()">
        <span aria-hidden="true" role="presentation" class="esri-icon esri-icon-table"></span>
    </div>

    <!-- Measure line -->
    <div id="distanceBtn" [ngClass]="measurementActive ? 'measurementActive' : ''" class="esri-widget--button esri-widget esri-interactive home" role="button" title="Distance Measurement" tabindex="0" (click)="changeMeasurementType('distance')" (keyup.enter)="changeMeasurementType('distance')"
        (keyup.space)="changeMeasurementType('distance')">
        <span id="distanceBtnSpan" aria-hidden="true" role="presentation" class="esri-icon esri-icon-measure-line"></span>
    </div>

    <!-- Measure area -->
    <div id="distanceAreaBtn" [ngClass]="measurementAreaActive ? 'measurementAreaActive' : ''" class="esri-widget--button esri-widget esri-interactive home" role="button" title="Area Measurement" tabindex="0" (click)="changeMeasurementType('area')" (keyup.enter)="changeMeasurementType('area')"
        (keyup.space)="changeMeasurementType('area')">
        <span id="distanceAreaBtnSpan" aria-hidden="true" role="presentation" class="esri-icon esri-icon-measure-area"></span>
    </div>

    <!-- Coordinate conversion -->
    <div id="coordinateConversionBtn" [ngClass]="coordinateActive ? 'coordinateActive' : ''" class="esri-widget--button esri-widget esri-interactive homee" role="button" title="Coordinates" tabindex="0" (click)="activateCoordinateWidget()" (keyup.enter)="activateCoordinateWidget()"
        (keyup.space)="activateCoordinateWidget()">
        <span aria-hidden="true" role="presentation" class="esri-icon esri-icon-globe"></span>
    </div>

    <!-- Print map -->
    <div id="printBtn" [ngClass]="printActive ? 'printActive' : ''" class="esri-widget--button esri-widget esri-interactive home" role="button" title="Print" tabindex="0" (click)="togglePrint()" (keyup.enter)="togglePrint()" (keyup.space)="togglePrint()">
        <span aria-hidden="true" role="presentation" class="esri-icon esri-icon-printer"></span>
    </div>

    <!-- Login widget -->
    <div id="loginBtn" [ngClass]="loggedIn ? 'loggedIn' : ''" class="esri-widget--button esri-widget esri-interactive home" role="button" title="Login" tabindex="0" (click)="userLogin()" (keyup.enter)="userLogin()" (keyup.space)="userLogin()">
        <span aria-hidden="true" role="presentation" class="esri-icon esri-icon-user"></span>
    </div>

</div>